module.exports = __webpack_public_path__ + "assets/img/1.4acc9f87.png";